module.exports = __webpack_public_path__ + "static/media/icon_snow_flake.a075ca44.svg";